import React, {FC, useEffect, useState} from 'react';
import ReactPlayer from "react-player";
import {IVideoItem} from "../../types/types";
import {useTelegram} from "../../hooks/useTelegram";

const posterUrl='https://lh5.googleusercontent.com/p/AF1QipP_flmzEaqNdU2ryM2z0z8SPwmtTqioc1eZwRaG=w426-h240-k-no'

interface IVideoItemProps {
    video:IVideoItem
}
const VideoItem:FC<IVideoItemProps> = ({video}) => {
    const [isLoading,setLoading]=useState<boolean>(false)
    const {tg} = useTelegram()

    useEffect(()=>{
        if (isLoading){
            tg.ready()
        }
    },[isLoading])
    return (
        <div  className="videoList__item">
            <ReactPlayer
                type="video/mp4"
                width='100%'
                height='580px'
                controls={true}
                url={video.url}
                fileConfig={{ attributes: { poster:posterUrl } }}
                onReady={ player => setLoading(true)}
            />
        </div>
    );
};

export default VideoItem;